const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopyHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-888 -133)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(888 133)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 211",
    d: "M0 0h12.334v12.334H0z",
    style: {
      fill: "none"
    },
    transform: "translate(892.833 137.833)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 212",
    d: "M9.1 1H3.014A1.022 1.022 0 0 0 2 2.023v7.162h1.014V2.023H9.1zm1.521 2.046H5.043a1.022 1.022 0 0 0-1.014 1.023v7.162a1.022 1.022 0 0 0 1.014 1.023h5.579a1.022 1.022 0 0 0 1.014-1.023V4.069a1.022 1.022 0 0 0-1.014-1.023zm0 8.185H5.043V4.069h5.579z",
    transform: "translate(891.912 137.373)",
    style: {
      fill: "#0222ba"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyHover);
export default __webpack_public_path__ + "static/media/icon-copy-hover.2623cbe1df0770b1c54c29eda8b798b7.svg";
export { ForwardRef as ReactComponent };